import React from 'react';

const GraduationCapIcon = () => (
    <svg 
        width="18" 
        height="18" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="graduation-cap-icon"
    >
        <path 
            d="M12 3L1 9L12 15L21 10.09V17H23V9L12 3ZM5 13.18V17.18C5 17.97 5.84 19.67 12 19.67S19 17.97 19 17.18V13.18L12 15.67L5 13.18Z" 
            fill="currentColor"
        />
    </svg>
);

const ScrollingBanner = () => {
    const bannerText = [
        "SONHOS", "🎓", "REALIZAÇÃO", "🎓", "FELICIDADE", "🎓", 
        "DEDICAÇÃO", "🎓", "FUTURO", "🎓", "SUCESSO", "🎓"
    ];

    // Criar múltiplas cópias para movimento infinito suave
    const repeatCount = 20;
    const repeatedContent = Array(repeatCount).fill(bannerText).flat();
    
    console.log('ScrollingBanner renderizado com', repeatedContent.length, 'itens');

    return (
        <section className="scrolling-banner-section">
            <div className="scrolling-banner">
                <div className="banner-track">
                    <div className="banner-content banner-content-1">
                        {repeatedContent.map((item, index) => (
                            <span key={`first-${index}`} className={`banner-item ${item === "🎓" ? 'banner-icon' : 'banner-text'}`}>
                                {item === "🎓" ? <GraduationCapIcon /> : item}
                            </span>
                        ))}
                    </div>
                    <div className="banner-content banner-content-2">
                        {repeatedContent.map((item, index) => (
                            <span key={`second-${index}`} className={`banner-item ${item === "🎓" ? 'banner-icon' : 'banner-text'}`}>
                                {item === "🎓" ? <GraduationCapIcon /> : item}
                            </span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ScrollingBanner;